import { render, staticRenderFns } from "./mainInfo.vue?vue&type=template&id=185ece2b&scoped=true"
import script from "./mainInfo.vue?vue&type=script&lang=js"
export * from "./mainInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185ece2b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('185ece2b')) {
      api.createRecord('185ece2b', component.options)
    } else {
      api.reload('185ece2b', component.options)
    }
    module.hot.accept("./mainInfo.vue?vue&type=template&id=185ece2b&scoped=true", function () {
      api.rerender('185ece2b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/credit/mainInfo.vue"
export default component.exports